import cn from 'classnames';
import { GrFormCheckmark } from 'react-icons/gr';

import styles from './Stepper.module.scss';

export default function Stepper({ data = [], activeStep = 0, maxWidth = '100%', wrapperStyle = {} }) {
  return (
    <div className={cn(styles.container, wrapperStyle)} style={{ maxWidth }}>
      {data.map((step, index) => (
        <div
          className={cn(styles.step, {
            [styles.lowEmphasis]: activeStep < index,
            [styles.completeStep]: activeStep > index,
          })}
          key={step.text}
        >
          <div className={cn(styles.counter, { [styles.prevCounter]: activeStep > index })}>
            {activeStep > index ? <GrFormCheckmark className={styles.checkmark} /> : index + 1}
          </div>
          <p className={styles.text} style={{ width: step.width }}>
            {step.text}
          </p>
        </div>
      ))}
    </div>
  );
}
